import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const fetchProducts = async ({ pageParam = 1, token }) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/product/admin/all-products?page=${pageParam}&limit=25`,
    {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch products');
  }

  return response.json();
};

const  useProduct = () => {
  const { token } = useContext(AuthContext);
  return useInfiniteQuery('products', ({ pageParam = 1 }) => fetchProducts({ pageParam, token }), {
    getNextPageParam: (lastPage) => {
      const limit = lastPage.limit || 25;
      const nextPage = lastPage.currentPage + 1;
      return nextPage <= Math.ceil(lastPage.totalProducts / limit) ? nextPage : undefined;
    }
  });
};

export default  useProduct;
